import ajax from "../../lib/appfuse-react/core/ajax";
import downloader from "../../lib/appfuse-react/core/downloader";
import Predicate from "../../lib/appfuse-react/core/Predicate";

const utilService = {
    // 找縣市
    findCounty: async () => {
        const response = await ajax.get('counties/findAll');
        return response.data;
    },
    // 找同區用縣市
    findCountyForFarms: async () => {
        const response = await ajax.get('counties/findAllForFarms');
        return response.data;
    },
    // 找銀行
    getBanks: async () => {
        const response = await ajax.get('banks/findAll');
        return response.data;
    },
    // 找作物品項
    getCropCategories: async () => {
        const response = await ajax.get('cropCategories/findAll');
        return response.data;
    },
    //搜尋作物品項
    searchCropCategories: async (predicate) => {
        const response = await ajax.get('cropCategories', {predicate});
        return response.data;
    },

    // 找地段
    getLandLots: async (url) => {
        const response = await ajax.get(url);
        return response.data;
    },
    // 找肥培資材
    findAllFertilizerMaterials: async () => {
        const response = await ajax.get(`cropApplications/fertilizerMaterials`);
        return response.data;
    },
    // 找防治資材
    findAllPreventionMaterials: async () => {
        const response = await ajax.get('cropApplications/preventionMaterials');
        return response.data;
    },
    // 用登記字號搜尋防治資材
    searchPreventionMaterials: async (registeredNo) => {
        const predicate = Predicate.like('許可證號', registeredNo);
        const response = await ajax.get('cropApplications/preventionMaterials', {predicate});
        return response.data;
    },

    exportFarms: async (url) => {
        await downloader.save(url);
    },

    importFarms: async (url, data) => {
        const response = await ajax.post(url, data);
        return response.data;
    },

    downloadImportFarms: async (url) => {
        await downloader.save(url);
    },

    downloadFile: async (file) => {
        await downloader.save(file);
    },

    //找經營體選項(違規案件資訊)
    getProcessingCustomerOptions: async () => {
        const response = await ajax.get('processingCustomers/customerOptions');
        return response.data;
    },

    getValidProducts: async (url, {predicate}) => {
        const response = await ajax.get(url, {predicate});
        return response.data;
    },

    getByUrl: async (url) => {
        const response = await ajax.get(url);
        return response.data;
    },

    saveByUrl: async (url, data) => {
        const response = await ajax.patch(url ,data);
        return response.data;
    },

    postByUrl: async (url, data) => {
        const response = await ajax.post(url, data);
        return response.data;
    },

    deleteByUrl: async (url) => {
        await ajax.delete(url);
    },
}

export default utilService;